import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { FormattedMessage } from "react-intl";
import { getDuration } from "sr/utils/api/masterData/getDuration";

type Props = {
  data: { duration?: string };
  HandleDataProps: (payload: { duration: string }) => void;
  externalErrorId?: string;
};

const RequirementDurationChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [duration, setDuration] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    setDuration(data?.duration || "");
  }, [data?.duration]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getDuration();
        if (res?.success && Array.isArray(res.data)) {
          const mapped = res.data.map((item: any) => ({
            value: item.value,
            label: item.label,
          }));
          setOptions(mapped);
        }
      } catch {}
    };
    load();
  }, []);

  useEffect(() => {
    HandleDataProps({ duration });
  }, [duration]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!duration?.trim()) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.DURATION');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => ({ duration }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Duration</p>
      <DropDown
        value={duration}
        onChange={(e) => setDuration(e.target.value)}
        name="duration"
        className="h-11 mt-2 border border-zinc-800 rounded-lg"
        error={externalErrorId || errorId}
      >
        <option value="">Select Duration</option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            <FormattedMessage id={opt.label} defaultMessage={opt.label} />
          </option>
        ))}
      </DropDown>
    </div>
  );
});

export default RequirementDurationChange;
